import request from '../request'

export const inventoryApi = {
  // 获取所有盘货时间
  getAllInventory () {
    return request.get('inventoryTime/getAllInventory')
  },

  // 创建盘货时间
  createInventory (data) {
    return request.post('inventoryTime/creatInventory', data)
  },

  // 删除盘货时间
  deleteInventory (id) {
    return request.get('inventoryTime/deleteById', { params: { id } })
  },

  // 根据盘货ID查找商品
  findItemByInventoryId (inventoryId, flag) {
    return request.post('inventoryHasGoods/findItemByInventoryId', { inventoryId, flag })
  },

  // 添加商品到盘货
  addToInventory (data) {
    return request.post('inventoryHasGoods/addToInventory', data)
  },

  // 从盘货中移除商品
  removeFromInventory (inventoryTimeId, goodsId) {
    return request.post('inventoryHasGoods/delete', { inventoryTimeId, goodsId })
  },

  // 获取商品盘货历史
  getInventoryHistory (goodsId) {
    return request.get('inventoryHasGoods/getInventoryHis', { params: { goodsId } })
  }
}



// WEBPACK FOOTER //
// ./src/api/modules/inventory.js